import { render, staticRenderFns } from "./Statistiche.vue?vue&type=template&id=74df2f82"
import script from "./Statistiche.vue?vue&type=script&lang=js"
export * from "./Statistiche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports